<template>
    <div class="lead">
        <div class="lead-content">
            <div class="lead-content-header">
                <div>
                    <p class="lead-title">{{ leadData.title }}</p>
                    <div class="lead-tags">
                        <div class="lead-tag" :key="tag.id" v-for="tag in leadData.tags">
                            <p>{{ tag.name }}</p>
                            <v-icon v-on:click="removeTag(leadData.offerLeadId, tag.id)">fas fa-times</v-icon>
                        </div>
                        <select class="lead-add-tag" v-model="selectedTag">
                            <option selected disabled :value="null">+ Adicionar Tag</option>
                            <option :value="tag.id" v-for="tag in tags" :key="tag.id">{{ tag.name }}</option>
                        </select>
                    </div>
                </div>
                <select class="lead-change-status" v-model="leadData.leadStatusId">
                    <optgroup :disabled="semantic.id < leadData.semanticId" :label="semantic.name" v-for="semantic in offerLeadStatus" :key="semantic.id">
                        <option :value="status.id" v-for="status in semantic.status" :key="status.id">{{ status.name }}</option>
                    </optgroup>
                </select>
            </div>
            <div class="step-container">
                <div class="step-bar" :style="bar"></div>
                <div class="step" v-for="(step, i) in semanticFlow" :key="i">
                    <div :class="`step-item ${step.id <= leadData.semanticId && !failSemantic ? 'active' : ''}`">
                        <v-icon>fa-check</v-icon>
                    </div>
                    <p :class="`step-title ${step.id <= leadData.semanticId && !failSemantic ? 'active' : ''}`">{{ step.name }}</p>
                </div>

                <div class="step">
                    <div :class="`step-item ${failSemantic ? 'fail active' : ''}`">
                        <v-icon>fa-times</v-icon>
                    </div>
                    <p :class="`step-title ${failSemantic ? 'fail active' : ''}`">{{ failSemantic ? failSemantic.name : 'Abortado'}}</p>
                </div>
            </div>
        </div>
        <div class="divisor" />
        <div class="lead-details">
            <div class="card-info-row">
                <div class="card-info avatar">
                    <!-- <v-img v-if="lead.affiliateAvatar" class="card-avatar-image" :src="$config.imageUri(lead.affiliateAvatar, 'photo')" /> -->
                    <div class="card-avatar">{{ leadData.affiliateName ? leadData.affiliateName.substring(0,1).toUpperCase() : '' }}</div>
                    <div class="card-info">
                        <label for=""><b>Referenciado por:</b></label>
                        <p>{{ leadData.affiliateName ? leadData.affiliateName : "Nenhum afiliado" }}</p>
                    </div>
                </div>
            </div>
            <div class="card-info-row">
                <div class="card-info">
                    <label for=""><b>Data de criação:</b></label>
                    <p>{{ $moment(leadData.createdAt).format("DD/MM/YYYY HH:mm") }}</p>
                </div>
                <div class="card-info">
                    <label for=""><b>Ultima atualização:</b></label>
                    <p>{{ $moment(leadData.offerStatusAt).format("DD/MM/YYYY HH:mm") }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        lead: {
            type: Object,
            required: true
        },
        offerLeadStatus: {
            type: Array,
            required: true
        },
        tags: {
            type: Array,
            required: true
        },
    },

    data() {
        return {
            width: 0,
            leadData: this.lead,
            selectedTag: null,
            semanticFlow: [],
            failSemantic: null,
        }
    },

    watch: {
        'leadData.leadStatusId': function(statusId) {
            this.updateBlock(this.leadData.offerLeadId, statusId);
        },

        'selectedTag': function(offerTagId) {
            if (offerTagId) {
                this.addTag(this.leadData.offerLeadId, offerTagId);
            }
        }
    },

    methods: {
        async updateBlock(offerLeadId, statusId) {
			try {
				let newOfferLead = await this.$api.dataService.execute('offerLead/updateOfferLeadStatus', { offerLeadId, offerLeadStatus: { id: statusId } });
                this.leadData = Object.assign(this.leadData, newOfferLead);
			} catch(e) {
				// TODO handle error
			}
		},

        async addTag(offerLeadId, offerTagId) {
            this.selectedTag = null;
            
			try {
				let tags = await this.$api.dataService.execute('offerLead/addTag', { offerLeadId, offerTagId });
                this.leadData.tags = tags;
			} catch(e) {
				// TODO handle error
			}
		},

        async removeTag(offerLeadId, offerTagId) {
            this.selectedTag = null;
            
			try {
				let tags = await this.$api.dataService.execute('offerLead/removeTag', { offerLeadId, offerTagId });
                this.leadData.tags = tags;
			} catch(e) {
				// TODO handle error
			}
		},
    },

    computed: {
        bar() {
            return `left: ${this.width / 2}px; width: ${this.width * (this.semanticFlow.length - 1)}px;`
        }
    },

    mounted() {
        this.width = document.querySelector('.step').offsetWidth;
    },
    
    created() {
        this.semanticFlow = this.leadData.semantic.filter(semantic => semantic.fail != 'S');

        let failSemanticList = this.leadData.semantic.filter(semantic => semantic.fail == 'S');
        this.failSemantic = failSemanticList.find(semantic => semantic.id == this.leadData.semanticId);
    }
}
</script>

<style scoped>
    p {
        margin: 0;
    }

    .lead {
        width: 100%;
        padding: 20px;
        background-color: #fff;
        border-radius: 5px;
        /* box-shadow: 0 5px 20px 0 rgba(0,0,0, 0.15); */
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .lead-title {
        font-size: 16px;
        font-weight: bold;
        color: var(--primary-color);
        margin-bottom: 2px;
    }

    .divisor {
        width: 2px;
        background-color: #f1f1f1;
        margin: 0 20px;
        flex: none;
        border-radius: 5px;
    }

    .lead-content {
        width: 100%;
    }

    .lead-content-header {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
    }

    .lead-tags {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 5px;
    }

    .lead-tag {
        padding: 3px 7px;
        font-size: 12px;
        border-radius: 100px;
        background-color: #EFEFEF;
        color: var(--primary-color);
        display: flex;
        flex-direction: row;
        gap: 5px;
        justify-content: baseline;
        align-items: baseline;
    }

    .lead-tag i {
        font-size: 12px;
    }

    .lead-change-status, .lead-add-tag {
        padding: 5px 10px;
        border-radius: 5px;
        background-color: var(--background-color);
        -moz-appearance: listbox;
        -webkit-appearance: listbox;
    }

    .lead-add-tag {
        padding: 2px 5px;
        font-size: 12px;
        background-color: var(--primary-color-hover);
        color: white;
        cursor: pointer;
    }

    .lead-details {
        min-width: 200px;
        display: flex;
        flex-direction: column;
        flex: none;
        gap: 10px;
    }

    .lead-detail {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
        color: var(--neutral-color);
        margin-top: 20px;
    }

    .lead-detail i {
        margin-right: 5px;
        color: var(--primary-color);
    }

    .card-info {
        display: flex;
        flex-direction: column;
    }

    .card-info > label {
        font-size: 12px;
        color: var(--gray-color);
    }

    .card-info.avatar {
        flex-direction: row;
        align-items: center;
    }

    .card-info-row {
        display: flex;
        flex-direction: row;
        gap: 20px;
    }

    .card-avatar {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        background-color: var(--primary-color);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        font-weight: bold;
        color: var(--white-color);
        margin-right: 10px;
    }

    .card-avatar-image {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 22px;
        font-weight: bold;
        color: var(--white-color);
        margin-right: 10px;
    }

    .card-info span {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px;
    }

    .step-container {
        display: flex;
        flex-direction: row;
        flex: 1;
        justify-content: space-between;
        margin-top: 25px;
        position: relative;
    }

    .step {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        flex: 1;
        position: relative;
    }

    .step-title {
        font-size: 12px;
        font-weight: bold;
        color: var(--neutral-color);
        margin-top: 5px;
        text-align: center;
    }

    .step-subtitle {
        font-size: 12px;
        text-align: center;
        font-weight: bold;
        color: #262626;
    }

    .step-title.active {
        color: var(--primary-color);
    }

    .step-title.fail {
        padding: 3px 5px;
        border-radius: 3px;
        background-color: var(--danger-color);
        color: var(--white-color);
    }

    .step-item {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: var(--white-color);
        border: 3px solid var(--neutral-color);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2;
        margin-top: 2px;
    }

    .step-item.fail {
        border: 3px solid var(--danger-color);
    }

    .step-item i {
        font-size: 12px;
        color: white;
    }

    .step-item.active {
        width: 25px;
        height: 25px;
        background-color: var(--primary-color);
        border: none;
        margin-top: 0;
    }

    .step-item.active.fail {
        background-color: var(--danger-color);
    }

    .step-bar {
        height: 3px;
        background-color: var(--neutral-color);
        position: absolute;
        top: 10px;
    }

    .detail-button {
        width: 100%;
        padding: 5px;
        border-radius: 5px;
        border: 2px solid var(--primary-color);
        transition: .2s;
        font-weight: bold;
    }

    .detail-button:hover {
        background-color: var(--primary-color);
        color: var(--white-color);
    }
</style>


// WEBPACK FOOTER //
// src/components/Prospection/Lead.vue